// React core components
import React from "react";

// @mui core components
import { CircularProgress } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const Feedback = () => {
  const formUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSfWkOK-in_bMMoHSZfcIvAeO58PAH9wrDqcxnJABHaxiDqhSA/viewform?usp=sf_link";
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDTypography variant="h3" mt={2}>
        Feedback
      </MDTypography>
      <iframe
        src={`${formUrl}?embedded=true`}
        width="100%"
        height="1000"
        title="Google Form"
      >
        <CircularProgress color="info" size={10} />
        Loading…
      </iframe>
      <MDBox mt={4} />
      
    </DashboardLayout>
  );
};

export default Feedback;
